// Module
var code = "<p>You can create a Purchase Order, pick your delivery address, and send it directly to your Suppliers via email. Users on the Pro Tier can also upload their Supplier's Product Catalogue into Powered Now to more accurately calculate the material cost of a job.</p>";
// Exports
module.exports = code;